import {defineStore} from 'pinia';

import {fetchWrapper} from '@/helpers/fetch-wrapper';
import {showSuccessToast, showToast} from "vant";

const baseUrl = `${process.env.VUE_APP_API_URL}/user`;

export const useUserStore = defineStore({
    id: 'user',
    state: () => ({
        user: {},
        timezones: []
    }),
    actions: {
        async fetchUser() {
            const response = await fetchWrapper.get(`${baseUrl}/`);
            this.user = response.data;
            localStorage.setItem('user', JSON.stringify(this.user));
        },

        async updateUserName() {
            try {
                const response = await fetchWrapper.put(`${baseUrl}/name`, {
                    "first_name": this.user.first_name,
                    "last_name": this.user.last_name,
                    "nickname": this.user.nickname,
                });
                this.user = response.data;
                localStorage.setItem('user', JSON.stringify(this.user));
                showSuccessToast('Updated');
            } catch (error) {
                showToast({
                    message: error,
                    wordBreak: 'break-word',
                });
            }
        },

        async updateUserEmail(email, password) {
            try {
                const response = await fetchWrapper.put(`${baseUrl}/email`, {
                    "email": email,
                    "password": password,
                });
                this.user = response.data;
                localStorage.setItem('user', JSON.stringify(this.user));
                showSuccessToast('Updated');
            } catch (error) {
                showToast({
                    message: error,
                    wordBreak: 'break-word',
                });
            }
        },

        async updateUserPassword(oldPassword, newPassword, passwordConfirmation) {
            try {
                const response = await fetchWrapper.put(`${baseUrl}/password`, {
                    "old_password": oldPassword,
                    "password": newPassword,
                    "password_confirmation": passwordConfirmation,
                });
                this.user = response.data;
                localStorage.setItem('user', JSON.stringify(this.user));
                showSuccessToast('Updated');
            } catch (error) {
                showToast({
                    message: error,
                    wordBreak: 'break-word',
                });
            }
        },

        async fetchUserTimezones() {
            this.timezones = await fetchWrapper.get(`${process.env.VUE_APP_API_URL}/utils/timezones`);
        },

        async updateUserTimezone(timezoneId) {
            try {
                const response = await fetchWrapper.put(`${baseUrl}/timezone`, {
                    "timezone_id": timezoneId,
                });
                this.user = response.data;
                localStorage.setItem('user', JSON.stringify(this.user));
                showSuccessToast('Updated');
            } catch (error) {
                showToast({
                    message: error,
                    wordBreak: 'break-word',
                });
            }
        },

    }
});
